import React from 'react';
import { Box } from '@chakra-ui/react';
import BotMessage from './BotMessage';
import UserBubble from './UserBubble';

const MessageBubble = ({ message, colors, onItemPress }) => {
    const isUser = message.user === 'user' || message.source === 'whatsapp';
    return (
        <Box
            display="flex"
            justifyContent={isUser ? 'flex-end' : 'flex-start'}
            px={isUser ? 4 : 6}
            py={isUser ? 1 : 2}
        >
            {isUser
                ? <UserBubble message={message} colors={colors} />
                : <BotMessage message={message} colors={colors} onItemPress={onItemPress} />
            }
        </Box>
    );
};

export default MessageBubble;
